//@flow
import React from "react";
import AbsoluteDropdown from "components/AbsoluteDropdown";
import Button from "react-bootstrap/lib/Button";
import CountBadge from "components/CountBadge";
import Dropdown from "react-bootstrap/lib/Dropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";
import { getLocalizedText } from "data/utils";
import isEqual from "lodash/isEqual";
import styles from "components/FilterBar/SearchBucket/SearchBucket.module.css";

type Props = {
    multiple: boolean,
    activeRows: Array<number>,
    disable: () => void,
    handleSelectAll: () => void,
    handleDeselectAll: () => void,
    handleInvert: () => void,
};

const badge = {
    marginLeft: 3,
};

const Bucket = ({
    multiple,
    activeRows,
    availableRows,
    enable,
    disable,
    handleSelectAll,
    handleDeselectAll,
    handleInvert,
}: Props) =>
    multiple ? (
        <AbsoluteDropdown bsSize="small">
            <Dropdown.Toggle chrome>
                <span data-test="multiSelectionBucket" className={styles.value}>
                    {getLocalizedText("$multiselection:name")}
                </span>
                {Object.keys(activeRows).length > 0 && (
                    <span className={`text-sm ${styles.badge}`} style={badge}>
                        <CountBadge
                            count={Object.keys(activeRows).length}
                            title={getLocalizedText(
                                "$multiselection:selected",
                                {
                                    count: Object.keys(activeRows).length,
                                    totalCount:
                                        Object.keys(availableRows).length,
                                }
                            )}
                        />
                    </span>
                )}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <MenuItem onSelect={disable} data-test="multiSelectionDisable">
                    {getLocalizedText("$multiselection:disable")}
                </MenuItem>
                {!isEqual(activeRows, availableRows) && (
                    <MenuItem onSelect={handleSelectAll}>
                        {getLocalizedText("$multiselection:selectAll")}
                    </MenuItem>
                )}
                {Object.keys(activeRows).length > 0 && (
                    <MenuItem onSelect={handleDeselectAll}>
                        {getLocalizedText("$multiselection:deselectAll")}
                    </MenuItem>
                )}
                <MenuItem onSelect={handleInvert}>
                    {getLocalizedText("$multiselection:invert")}
                </MenuItem>
            </Dropdown.Menu>
        </AbsoluteDropdown>
    ) : (
        <Button
            bsSize="small"
            onClick={enable}
            disabled={Object.keys(availableRows).length === 0}
            data-test={"multiselectionButtonEnable"}
        >
            <span className={styles.value} data-test="multiSelectionEnable">
                {getLocalizedText("$multiselection:enable")}
            </span>
        </Button>
    );
Bucket.displayName = "MultiSelection.Bucket";

export default Bucket;
